const colors = [
  "#000033",
  "#0000CC",
  "#000066",
  "#003300",
  "#003333",
  "#0048BA",
  "#005b00",
  "#006600",
  "#006666",
  "#0066CC",
  "#0066FF",
  "#0096FF",
  "#1F51FF",
  "#330000",
  "#330033",
  "#330066",
  "#3366FF",
  "#339933",
  "#3399CC",
  "#339966",
  "#3333CC",
  "#333333",
  "#333366",
  "#333399",
  "#660000",
  "#660033",
  "#660066",
  "#6600FF",
  "#66FFFF",
  "#6666FF",
  "#6699FF",
  "#66CCFF",
  "#990000",
  "#990033",
  "#9900CC",
  "#990099",
  "#99CC66",
  "#99CC99",
  "#99CCCC",
  "#99CCFF",
  "#9933FF",
  "#9966FF",
  "#99FF00",
  "#B0BF1A",
  "#CC0000",
  "#CC00CC",
  "#CC0033",
  "#CC0099",
  "#CC00FF",
  "#CC3300",
  "#CC3399",
  "#CCFF66",
  "#CCFF99",
  "#CCFFFF",
  "#CC99FF",
  "#CCCCFF",
  "#CCCC00",
  "#CCCC33",
  "#CCCC99",
  "#CCCCCC",
  "#FD1FB3",
  "#ffdbff",
  "#FF0033",
  "#FF0066",
  "#FFCCFF",
  "#FFCC66",
  "#FFFF99",
  "#FFFFCC",
  "#FFFF33",
  "#FFCC33",
  "#FF3333",
  "#FFF922",
  "#FF3366",
  "#FF6600",
  "#FF6699",
  "#FF9900",
  "#FF9933",
  "#FF99FF",
  "#FF9999",
  "#FF9966",
  "aqua",
  "aquamarine",
  "black",
  "blue",
  "blueviolet",
  "brown",
  "cadetblue",
  "chartreuse",
  "chocolate",
  "coral",
  "cornflowerblue",
  "cornsilk",
  "crimson",
  "cyan",
  "darkblue",
  "darkgoldenrod",
  "darkgreen",
  "darkkhaki",
  "darkmagenta",
  "darkolivegreen",
  "darkorange",
  "darkorchid",
  "darkred",
  "darkseagreen",
  "darkslateblue",
  "darkslategrey",
  "darkturquoise",
  "darkviolet",
  "deeppink",
  "deepskyblue",
  "dodgerblue",
  "firebrick",
  "forestgreen",
  "fuchsia",
  "ghostwhite",
  "gold",
  "goldenrod",
  "gray",
  "green",
  "greenyellow",
  "hotpink",
  "indianred",
  "indigo",
  "ivory",
  "khaki",
  "lavender",
  "lavenderblush",
  "lawngreen",
  "lemonchiffon",
  "lightcoral",
  "lightgrey",
  "lightpink",
  "lightsalmon",
  "lightseagreen",
  "lightskyblue",
  "lightslategrey",
  "lightsteelblue",
  "lightyellow",
  "lime",
  "limegreen",
  "magenta",
  "maroon",
  "mediumaquamarine",
  "mediumblue",
  "mediumorchid",
  "mediumpurple",
  "mediumseagreen",
  "mediumslateblue",
  "mediumspringgreen",
  "mediumturquoise",
  "mediumvioletred",
  "midnightblue",
  "navajowhite",
  "navy",
  "olive",
  "olivedrab",
  "orange",
  "orangered",
  "orchid",
  "palegreen",
  "paleturquoise",
  "peru",
  "pink",
  "plum",
  "powderblue",
  "purple",
  "rebeccapurple",
  "red",
  "rosybrown",
  "royalblue",
  "saddlebrown",
  "salmon",
  "sandybrown",
  "seagreen",
  "sienna",
  "silver",
  "skyblue",
  "slateblue",
  "slategray",
  "springgreen",
  "steelblue",
  "teal",
  "tomato",
  "turquoise",
  "violet",
  "whitesmoke",
  "yellow",
  "yellowgreen",
];

export default colors;
